<div class="wrap">
    <!-- title -->
    <h1 [class]="[component.title_style || '', component.title_align || '', component.title_color || '']"
        *iCms="'title' of component; skipEmpty: true"></h1>

    <!-- tabs -->
    <div class="w-12 flex flex-wrap-s p-t-3">
        @for (tab of component.tabs; track $index) {
        <div class="w-3 w-12-s flex flex-wrap p-a-3 m-b-4-s"
             [class]="[tab.text_style ||'', tab.text_color || '', tab.tab_bg_color || '', !$last ? 'm-r-3 m-r-0-s' : '']">

            <!-- tab number -->
            <span class="w-12 center h1">{{$index + 1}}</span>

            <!-- tab text -->
            <span class="w-12 flex center"
                  *iCms="'text' of tab"></span>

            <!-- additional text -->
            <span class="w-12 p2 center"
                  *iCms="'additional_text' of tab"></span>
        </div>
        }
    </div>
</div>